import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const RatingContainer = styled.div<{ margin?: number }>`
  align-items: center;
  display: flex;
  margin-left: ${(props) => (props?.margin || 0) * Screen.widthRatio}px;
  margin-right: ${(props) => (props?.margin || 0) * Screen.widthRatio}px;
`;

export default RatingContainer;
